<template>
  <div>
    <p
      v-if="productPriceDisplay === 'inclusive_charge'"
      class="text-xs text-gray-700 mt-2"
    >
      {{ $t("tax_included") }}
    </p>
    <table
      v-if="
        value && value.length > 0 && productPriceDisplay !== 'inclusive_charge'
      "
      class="w-full text-xs text-gray-700 mt-3"
    >
      <tbody>
        <tr
          v-for="(charge, index) in value"
          :key="`charge-${index}-${charge.amount}`"
        >
          <td>
            {{ charge.name }} (<Amount
              class="text-gray-500"
              :type="charge.type"
              :value="charge.value"
            />)
          </td>
          <td class="text-end"><Amount :value="charge.total" /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useBizStore } from "@/store/index.js";
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(useBizStore, ["productPriceDisplay"]),
  },
};
</script>
